/** Mock-up tokens (Material Design 3) — pre-writing 2026-10-07. */
export const LEARNER = {
  primary: '#2F5E9E',
  onPrimary: '#FFFFFF',
  secondaryContainer: '#DBE2F9',
  onSecondaryContainer: '#141B2C',
  surface: '#FFFFFF',
  surfaceContainerLow: '#F4F5F9',
  surfaceContainer: '#F0F2FA',
  onSurface: '#1A1C1E',
  onSurfaceVariant: '#44474F',
  outline: '#74777F',
  outlineVariant: '#C4C6D0',
  outlineVariantSoft: '#E1E2E8',
  successContainer: '#D3F0DA',
  onSuccessContainer: '#00210B',
  successIcon: '#1F6E3A',
  errorContainer: '#FFDAD6',
  onErrorContainer: '#410002',
  errorIcon: '#BA1A1A',
  disabled: '#E2E2E6',
  onDisabled: '#8E9099',
};

export const TREND_CHOICES = [
  { value: 'up', label: 'Up' },
  { value: 'down', label: 'Down' },
  { value: 'same', label: 'About the same' },
];
